/* eslint-disable */
export default {
  install: function(Vue) {
    Vue.prototype.fnCefGameBox = function(o) {
      if (!window.cefGameBox || !window.clientInfo) return
      let defaultData = o.data || ''
      if (o.method === 'clientOpenWnd') {
        let url = o.data.url

        defaultData = {
          url: url,
          width: o.data.width || 1400,
          height: o.data.height || 840,
          status: typeof o.data.status == 'undefined' ? 1 : o.data.status,
          top: o.data.top || 0,
          left: o.data.left || 0,
          center: o.data.center || true,
          type: o.data.type || 0,
          syncookie: o.data.syncookie || 1,
          topmost: o.data.topmost || 0,
          window_name: o.data.window_name || 'wndName' + Date.now(),
          window_title: o.data.window_title || '易乐玩游戏盒子',
          game_name: o.data.game_name || '',
          game_code: o.data.game_code || '',
          server_name: o.data.server_name || '',
          server_id: o.data.server_id || '',
          passport: o.data.passport || '',
          uid: o.data.uid || 0
        }
      }
      window.cefGameBox({
        request: JSON.stringify({
          method: o.method,
          data: defaultData
        }),
        onSuccess: function(response) {
          o.success && o.success(JSON.parse(response))
        },
        onFailure: function(response) {
          o.error && o.error(response)
        }
      })
    }
  }
}
